var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.caseInfo.caseInfo
    ? _c("div", { staticClass: "battleCaseDetail" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.caseInfo.caseInfo.caseName)),
          _c("span", [_vm._v("包含以下饰品")]),
        ]),
        _c("div", { staticClass: "probability" }, [
          _c("div", { staticClass: "title" }, [_vm._v("掉落概率")]),
          _c("div", { staticClass: "rate_list_con" }, [
            _c("ul", { staticClass: "rate_list" }, [
              _vm.caseInfo.caseInfo.groupRateG
                ? _c("li", { staticClass: "gold" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          (_vm.caseInfo.caseInfo.groupRateG / 100).toFixed(2)
                        ) +
                        "% "
                    ),
                  ])
                : _vm._e(),
              _vm.caseInfo.caseInfo.groupRateR
                ? _c("li", { staticClass: "red" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          (_vm.caseInfo.caseInfo.groupRateR / 100).toFixed(2)
                        ) +
                        "% "
                    ),
                  ])
                : _vm._e(),
              _vm.caseInfo.caseInfo.groupRateP
                ? _c("li", { staticClass: "purple" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          (_vm.caseInfo.caseInfo.groupRateP / 100).toFixed(2)
                        ) +
                        "% "
                    ),
                  ])
                : _vm._e(),
              _vm.caseInfo.caseInfo.groupRateW
                ? _c("li", [
                    _vm._v(
                      " " +
                        _vm._s(
                          (_vm.caseInfo.caseInfo.groupRateW / 100).toFixed(2)
                        ) +
                        "% "
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "battleCaselist" }, [
          _c(
            "div",
            { staticClass: "scroll" },
            _vm._l(_vm.caseInfo.items, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "item" },
                [
                  _c("c-award", {
                    staticClass: "award",
                    attrs: {
                      rarity: item.rarity,
                      picture: item.itempic,
                      name: item.itemname,
                      price: item.price,
                      rate: item.viewRate,
                      viewRate: item.rollRangeStr,
                      width: "100%",
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }